# Deps
import Vue from 'vue'

###
# Global components
###

# Fix for issues with body-scoll-lock and iOS Safari
# https://gitlab.com/papa-and-barkley/papa-and-barkley-platform/-/commit/0eacb7654452faadd8f47522a659d89b34c86c20#note_938115168
import Modal from '@bkwld/vue-modal'
Modal.mixins = [] unless Modal.mixins
Modal.mixins.push
	mounted: -> document.querySelector('html').style.height = '100vh'
	beforeDestroy: -> document.querySelector('html').style.height = ''

Vue.component 'modal', Modal
import '@bkwld/vue-modal/index.css'

import Embed from '@bkwld/vue-embed'
Vue.component 'vue-embed', Embed

import Hamburger from 'vue-hamburger'
Vue.component 'hamburger', Hamburger
import 'vue-hamburger/index.css'

# Import Accordion Wrapper globally to avoid cyclical imports in blocks-list
import AccordionWrapper from '~/components/blocks/accordion-wrapper'
Vue.component 'accordion-wrapper', AccordionWrapper

# Helper for explicit links
import SmartLink from '~/components/globals/smart-link'
Vue.component 'smart-link', SmartLink

# Cart Flyout
import CartFlyout from 'library/components/layout/cart-flyout/cart-flyout'
Vue.component 'cart-flyout', CartFlyout

# Number Stepper
import FormNumberStepper from 'library/components/globals/form/number-stepper'
Vue.component 'form-number-stepper', FormNumberStepper

# Checkbox
import FormCheckbox from 'library/components/globals/form/checkbox'
Vue.component 'form-checkbox', FormCheckbox

# Button Group
import FormButtonGroup from 'library/components/globals/form/button-group'
Vue.component 'form-button-group', FormButtonGroup

# Dropdown
import FormDropdown from 'library/components/globals/form/dropdown'
Vue.component 'form-dropdown', FormDropdown

# Radio List
import FormRadioList from 'library/components/globals/form/radio-list'
Vue.component 'form-radio-list', FormRadioList

# Radio
import FormRadio from 'library/components/globals/form/radio'
Vue.component 'form-radio', FormRadio

# Text Area
import FormTextarea from 'library/components/globals/form/textarea'
Vue.component 'form-textarea', FormTextarea

# Text Area
import FormTextfield from 'library/components/globals/form/textfield'
Vue.component 'form-textfield', FormTextfield

# Shopify Visual
import ShopifyVisual from 'library/components/globals/shopify-visual'
Vue.component 'shopify-visual', ShopifyVisual
Vue.component 'ShopifyVisual', ShopifyVisual
